<template>
  <div class="d-inline-flex align-center">
    <template v-if="meta.img">
      <div
        class="brand-badge-mask ml-2"
        :style="{
          width: size + 'px',
          height: size + 'px',
          backgroundColor: customColor || meta.colors[0],
          maskImage: `url(${meta.img})`,
          WebkitMaskImage: `url(${meta.img})`
        }"
      ></div>
    </template>
    <v-icon
      v-else
      :size="size"
      class="ml-2"
      :color="customColor || meta.colors[0]"
    >
      mdi-{{ meta.icon || meta.defaultIcon }}
    </v-icon>

    <span v-if="showTitle" class="store-type-label font-weight-medium">
      {{ meta.title||meta?.type }}
    </span>
  </div>
</template>

<script>
import { getPlatformMeta } from '../../../../../public/js/storePlatforms.js';

export default {
  name: "StoreBrandBadge",
  props: {
    type: { type: String, required: true },
    size: { type: [Number, String], default: 20 },
    customColor: { type: String, default: null },
    showTitle: { type: Boolean, default: false }
  },
  computed: {
    meta() {
      return getPlatformMeta(this.type);
    }
  }
};
</script>

<style scoped>
.brand-badge-mask {
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
  display: inline-block;
  vertical-align: middle;
}
</style>
